module.exports = __webpack_public_path__ + "static/media/bg_popup_frame52beaa0250b659bd26fdf7e32e23950d.webp";